"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initClientAndHub = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _utils = require("./utils");

var _integrations = _interopRequireDefault(require("../integrations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isCurrentHubError = function isCurrentHubError(error, url) {
  var _error$reason;

  var errorSources = [url, error === null || error === void 0 ? void 0 : error.stack, error === null || error === void 0 ? void 0 : (_error$reason = error.reason) === null || _error$reason === void 0 ? void 0 : _error$reason.stack]; // eslint-disable-next-line no-undef

  return errorSources.some(function (errorSource) {
    var _errorSource$includes;

    return errorSource === null || errorSource === void 0 ? void 0 : (_errorSource$includes = errorSource.includes) === null || _errorSource$includes === void 0 ? void 0 : _errorSource$includes.call(errorSource, __webpack_public_path__);
  });
};
/**
 * Для того, чтобы добавить какую-то ошибку в ignore,
 * нужно поправить динамическую настройку sentry_js_config в сервисе.
 */


var initClientAndHub = function initClientAndHub(_ref) {
  var sentryLoggingEnabled = _ref.sentryLoggingEnabled,
      sentryJsConfig = _ref.sentryJsConfig,
      sentryDSN = _ref.sentryDSN,
      buildVersion = _ref.buildVersion,
      staticHost = _ref.staticHost,
      getUser = _ref.getUser,
      getExtraData = _ref.getExtraData,
      _ref$beforeSendCallba = _ref.beforeSendCallback,
      beforeSendCallback = _ref$beforeSendCallba === void 0 ? null : _ref$beforeSendCallba,
      excludeStoreKeys = _ref.excludeStoreKeys;

  if (!sentryLoggingEnabled) {
    return {};
  }

  var environment = (0, _utils.getEnvironment)();
  var isSupportedBrowser = (0, _utils.isBrowserSupported)();
  var isLoggingEnabled = isSupportedBrowser || environment.isAutotests;

  if (!isLoggingEnabled) {
    return {};
  }

  var config = (0, _utils.prepareConfig)({
    sentryJsConfig: sentryJsConfig,
    sentryDSN: sentryDSN,
    buildVersion: buildVersion,
    staticHost: staticHost,
    beforeSendCallback: beforeSendCallback,
    getUser: getUser,
    getExtraData: getExtraData,
    excludeStoreKeys: excludeStoreKeys
  });
  var client = new Sentry.BrowserClient(_objectSpread(_objectSpread({}, config), {}, {
    transport: Sentry.makeFetchTransport,
    integrations: _toConsumableArray(_integrations.default)
  }));
  client.setupIntegrations();
  var hub = new Sentry.Hub(client);
  hub.configureScope((0, _utils.prepareScope)(environment, getExtraData, getUser));
  var prevOnError = window.onerror;
  var prevOnUnhandledRejection = window.onunhandledrejection;

  window.onerror = function (message, url, line, col, error) {
    if (isCurrentHubError(error, url)) {
      hub.captureException(error);
      return false;
    }

    if (prevOnError) {
      return prevOnError(message, url, line, col, error);
    }

    return false;
  };

  window.onunhandledrejection = function (error) {
    if (isCurrentHubError(error)) {
      hub.captureException(error);
      return false;
    }

    if (prevOnUnhandledRejection) {
      return prevOnUnhandledRejection(error);
    }

    return false;
  };

  return {
    client: client,
    hub: hub
  };
};

exports.initClientAndHub = initClientAndHub;
var _default = initClientAndHub;
exports.default = _default;